import { findIndex } from 'lodash';
import { Subject, takeUntil } from 'rxjs';
import * as headbreaker from 'headbreaker';
import { Component, Output, EventEmitter, ChangeDetectorRef, ElementRef } from '@angular/core';

import { MobileQuestsService, MobileThemeService } from '@sifca-monorepo/clients';
import { QuestActivityType } from '@sifca-monorepo/widget-generator';

@Component({
  template: '',
})
export class MobileJigsawPuzzleComponent {
  protected unsubscribeAll: Subject<any> = new Subject<any>();

  @Output() performActivity = new EventEmitter<boolean>();

  imgData: string;
  isDark: boolean;
  showImage = false;
  isPuzzleLoading = true;
  isButtonDisabled = true;
  isLastActivity: boolean;
  questActivities: QuestActivityType[];
  selectedQuestActivity: QuestActivityType;

  constructor(
    protected elRef: ElementRef,
    protected cd: ChangeDetectorRef,
    protected themeService: MobileThemeService,
    protected questsService: MobileQuestsService,
  ) {
    this.themeService.darkMode$.pipe(takeUntil(this.unsubscribeAll)).subscribe((isDark) => {
      this.isDark = isDark;
    });
    this.questsService.questActivitesByQuest$.pipe(takeUntil(this.unsubscribeAll)).subscribe((questActivitesByQuest) => {
      this.questActivities = questActivitesByQuest;
    });
    this.questsService.selectedQuestActivity$.pipe(takeUntil(this.unsubscribeAll)).subscribe((questActivity) => {
      this.selectedQuestActivity = questActivity;
      if (questActivity) {
        this.isLastActivity = this.selectedQuestActivity?.id === this.questActivities[this.questActivities?.length - 1]?.id;
      }
      this.imgData =
        questActivity?.activity?.action?.definition?.game?.jigsaw?.picture?.baseUrl +
        '/' +
        questActivity?.activity?.action?.definition?.game?.jigsaw?.picture?.path;
      });
  }

  ngOnInit() {
    this.play();
  }
  
  play() {
    const audio = new Audio('assets/sounds/audio/connect.wav');
    const calculateDimensions = () => {
      const containerWidth = window.innerWidth;
      const containerHeight = window.innerHeight;
      const aspectRatio = 4 / 3;
      let width = containerWidth;
      let height = containerWidth / aspectRatio;
      if (height > containerHeight) {
        height = containerHeight;
        width = containerHeight * aspectRatio;
      }
      return { width, height };
    };
    const initialDimensions = calculateDimensions();
    const berni = new Image();
    berni.src = this.imgData;
    const canvasEl = this.elRef.nativeElement.querySelector('#puzzle');
    const sound = new headbreaker.Canvas(canvasEl, {
      width: initialDimensions.width,
      height: window.innerWidth < 1200 ? initialDimensions.height * 1.5 : initialDimensions.height * 0.6,
      pieceSize: 60,
      proximity: 20,
      borderFill: 10,
      strokeWidth: 1.5,
      lineSoftness: 0.18,
      image: berni,
      strokeColor: this.isDark ? 'white' : 'black',
      preventOffstageDrag: true,
      painter: new headbreaker.painters.Konva({
        draggable: false,
      }),
    });
    berni.onload = () => {
      this.isPuzzleLoading = false;
      sound.adjustImagesToPuzzleHeight();
      sound.autogenerate({
        horizontalPiecesCount: this.selectedQuestActivity?.activity?.action?.definition?.game?.jigsaw?.pieces,
        verticalPiecesCount: this.selectedQuestActivity?.activity?.action?.definition?.game?.jigsaw?.pieces,
        insertsGenerator: headbreaker.generators.random,
      });
      sound.shuffleGrid();
      sound.draw();
      sound.onConnect((_piece, figure, _target, targetFigure) => {
        audio.play();
        figure.shape.stroke('yellow');
        targetFigure.shape.stroke('yellow');
        sound.redraw();
        sound.attachSolvedValidator();
        sound.onValid(() => {
          this.navigateNextSlide();
          this.isButtonDisabled = false;
        });
        setTimeout(() => {
          figure.shape.stroke(this.isDark ? 'white' : 'black');
          targetFigure.shape.stroke(this.isDark ? 'white' : 'black');
          sound.redraw();
        }, 200);
      });
      sound.onDisconnect((_it) => {
        audio.play();
      });
      this.cd.markForCheck();
    };
    ['resize', 'DOMContentLoaded'].forEach((event) => {
      window.addEventListener(event, () => {
        if (container) {
          var container = document.getElementById('puzzle');
          sound.resize(container.offsetWidth, container.scrollHeight);
          sound.scale(container.offsetWidth / initialDimensions.width);
          sound.redraw();
        }
      });
    });
  }

  navigateNextSlide() {
    if (this.isLastActivity) {
      this.performActivity.emit(true);
    } else {
      let index = findIndex(this.questActivities, (item) => item?.id === this.selectedQuestActivity?.id);
      this.questsService.selectedQuestActivity$ = this.questActivities[index + 1];
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }
}
